// extracted by mini-css-extract-plugin
export default {"container":"date-picker_container__q0DPd","mainButton":"date-picker_mainButton__ofc9Q","formattedDate":"date-picker_formattedDate__2oy6J"};